import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  ElementRef,
  EventEmitter,
  inject,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NZ_DRAWER_DATA, NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer';
import {
  Company,
  CrmTag,
  DocumentType,
  GetParams,
  Partner,
  Project,
  TableColumn,
  ToastConfig,
  User,
} from '@app/shared';
import {
  CompanyService,
  DocumentService,
  DrawerEscapeBlockerService,
  getSafeImageUrl,
  isExpirationAlert,
  OpportunityService,
  ProjectService,
  PartnerService,
} from '@app/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzModalService } from 'ng-zorro-antd/modal';
import { GlobalValuesService } from '@app/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize, take } from 'rxjs';
import { AuthService } from '../../../../core/services/auth.service';
import { ModifyPartnerDrawerComponent } from 'src/app/features/maestros/drawers/modify-partner-drawer/modify-partner-drawer.component';
import { CreateProjectDrawerComponent } from '../../../project/drawers/create-project-drawer/create-project-drawer.component';
import { isProjectAvailableForOpportunity } from '../../services/project-availability.util';

@Component({
  selector: 'app-oportunities-add-drawer',
  standalone: false,
  templateUrl: './oportunities-add-drawer.component.html',
  styleUrl: './oportunities-add-drawer.component.less',
})
export class OportunitiesAddDrawerComponent implements OnInit {
  nzData: {
    columnsData: TableColumn[];
    element: any; // Using 'any' to handle possible differences in the Partner model
    maestroName: string;
    editPermissions: boolean;
    type?: string; // 'Opportunity' o 'Lead'
    initialStage?: {
      id?: number | string;
      key?: string;
      title?: string;
    };
  } = inject(NZ_DRAWER_DATA);

  partner: any = null;
  columnsData: TableColumn[] = [];
  isEmployee = false;
  documents: any[] = [];
  documentTypes: DocumentType[] = [];
  oportunitiesForm!: FormGroup;
  step: 1 | 2 = 1;
  /** true mientras se está guardando con "Guardar y nuevo" */
  savingAndNew: boolean = false;
  /** true mientras se está guardando con "Guardar y cerrar" */
  savingAndClose: boolean = false;
  notRef: any;
  @ViewChild('notificationTmpl') notificationTmpl: any;
  @ViewChild('linkModalTemplate', { static: false }) linkModalTemplate!: TemplateRef<any>;
  @ViewChild('linkModalFooterTemplate', { static: false }) linkModalFooterTemplate!: TemplateRef<any>;
  @ViewChild('linkInput', { static: false }) linkInput?: ElementRef<HTMLInputElement>;
  @ViewChild('quillEditorRef', { static: false }) quillEditorRef: any;
  toastConfig: ToastConfig = {
    icon: 'check_circle',
    iconColor: '#6CDA75',
    content: 'Oportunidad creada.',
    showUndo: false,
  };
  @Output() openEditDrawerEvent = new EventEmitter<number>();
  protected readonly getSafeImageUrl = getSafeImageUrl;
  contactList: Partner[] = [];
  filteredContactList: Partner[] = [];
  contactLoading = false;
  projectsList: Project[] = [];
  readonly createProjectOptionValue = 'CREATE_PROJECT';
  loadingProjects: boolean = false;
  companiesList: Company[] = [];
  filteredCompaniesList: Company[] = [];
  filteredIntermediaryCompaniesList: Company[] = [];
  allCompaniesList: Company[] = [];
  usersList: User[] = [];
  commercialList: Partner[] = [];
  filteredCommercialList: Partner[] = [];
  costCenterList: { id: number; name: string }[] = [];
  tagsList: CrmTag[] = [];
  salesTeamList: {
    id: number;
    name: string;
    memberList?: any[];
    members?: any[];
  }[] = [];
  private allSalesTeamList: {
    id: number;
    name: string;
    memberList?: any[];
    members?: any[];
  }[] = [];
  isLead: boolean = false;
  hasTeamMembers: boolean = true; // Indica si el equipo seleccionado tiene miembros
  value: string | null = null;
  ModifyPartnerDrawerComponent = ModifyPartnerDrawerComponent;
  quillModules: any = {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ header: [1, 2, 3, false] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link'],
      ],
      handlers: {
        link: (value: boolean) => this.handleQuillLink(value),
      },
    },
  };
  linkModalUrl = '';
  private linkModalQuill: any = null;
  private linkModalRange: { index: number; length: number } | null = null;
  private linkModalRef: any = null;
  private destroyRef = inject(DestroyRef);

  private modalService = inject(NzModalService);

  constructor(
    private drawerRef: NzDrawerRef<string>,
    private documentService: DocumentService,
    private opportunityService: OpportunityService,
    private notificationService: NzNotificationService,
    private fb: FormBuilder,
    public globalValuesService: GlobalValuesService,
    private projectService: ProjectService,
    private companyService: CompanyService,
    private authService: AuthService,
    private partnerService: PartnerService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private drawerEscapeBlocker: DrawerEscapeBlockerService,
    private drawerService: NzDrawerService,
  ) {
    this.globalValuesService.isPartnerReady$
      .pipe(takeUntilDestroyed())
      .subscribe((value: boolean) => {
        if (value) {
          this.contactList = this.globalValuesService.origenContactList;
          this.filteredContactList = [...this.contactList];
        }
      });
    // Load companies via PartnerService (isCompany = true)
    this.partnerService
      .getCompanies()
      .pipe(takeUntilDestroyed())
      .subscribe((companies: Partner[] | any[]) => {
        this.companiesList = companies;
        this.filteredCompaniesList = [...companies];
        this.filteredIntermediaryCompaniesList = [...companies];
        if (
          this.oportunitiesForm &&
          !this.oportunitiesForm.get('companyId')?.value
        ) {
          const currentCompanyId = this.companyService.selectedCompanyId$.value;
          if (currentCompanyId) {
            this.oportunitiesForm.patchValue({ companyId: currentCompanyId });
          }
        }
      });

    // Load all companies
    this.globalValuesService.companies$
      .pipe(takeUntilDestroyed())
      .subscribe((companies: Company[]) => {
        this.allCompaniesList = companies;
        // Establecer el valor por defecto si el formulario ya está inicializado y no tiene valor
        if (
          this.oportunitiesForm &&
          !this.oportunitiesForm.get('companyId')?.value
        ) {
          const currentCompanyId = this.companyService.selectedCompanyId$.value;
          if (currentCompanyId) {
            this.oportunitiesForm.patchValue({ companyId: currentCompanyId });
          }
        }
      });

    // Load users
    this.globalValuesService.users$
      .pipe(takeUntilDestroyed())
      .subscribe((users: User[]) => {
        this.usersList = users;
        console.log('USers', this.usersList);
        // Mapear usuarios a partners para usar con avatar-select
        this.commercialList = users
          .filter((user) => user.partner)
          .map((user) => user.partner);
        console.log('commercialList', this.commercialList);

        // Inicializar filteredCommercialList como vacío hasta que se seleccione un equipo
        this.filteredCommercialList = [];

        // Si hay un equipo seleccionado, filtrar los comerciales
        const selectedTeamId = this.oportunitiesForm?.get('salesTeam')?.value;
        if (selectedTeamId) {
          this.filterCommercialsByTeam(selectedTeamId);
        }
        // Establecer el valor por defecto si el formulario ya está inicializado y no tiene valor
        if (
          this.oportunitiesForm &&
          !this.oportunitiesForm.get('commercial')?.value
        ) {
          const currentUser = this.authService.loggedUser$.value;
          if (currentUser?.partner?.id) {
            this.oportunitiesForm.patchValue({
              commercial: currentUser.partner.id,
            });
            // Autocompletar la información del comercial por defecto
            this.onCommercialChange(currentUser.partner.id);
          }
        }
      });

    // Load cost centers
    this.globalValuesService.costCenters$
      .pipe(takeUntilDestroyed())
      .subscribe((costCenters: { id: number; name: string }[]) => {
        this.costCenterList = costCenters;
      });

    // Load tags
    this.globalValuesService.crmTags$
      .pipe(takeUntilDestroyed())
      .subscribe((tags: CrmTag[] = []) => {
        // Filtrar solo las etiquetas activas
        this.tagsList = (tags || []).filter((tag) => tag.isActive);
      });

    // Load sales teams
    this.globalValuesService.salesTeams$
      .pipe(takeUntilDestroyed())
      .subscribe(
        (salesTeams: { id: number; name: string; memberList?: any[] }[]) => {
          this.allSalesTeamList = salesTeams || [];
          this.salesTeamList = this.filterSalesTeamsForInitialStage(
            this.allSalesTeamList,
          );
          console.log('Equipos de ventas cargados:', this.salesTeamList);
          // Verificar si los equipos tienen memberList
          this.salesTeamList.forEach((team) => {
            console.log(`Equipo ${team.name} (${team.id}):`, {
              hasMemberList: !!team.memberList,
              memberListLength: team.memberList?.length || 0,
            });
          });

          // Si hay un equipo seleccionado, actualizar la lista de comerciales
          const selectedTeamId = this.oportunitiesForm?.get('salesTeam')?.value;
          if (selectedTeamId) {
            this.filterCommercialsByTeam(selectedTeamId);
          }
        },
      );
  }

  /**
   * Filtrar la lista de contactos según el texto de búsqueda
   * @param searchValue Texto ingresado en el buscador
   */
  onContactSearch(searchValue: string): void {
    if (!searchValue || searchValue.trim() === '') {
      // Si no hay búsqueda, mostrar todos los contactos
      this.filteredContactList = [...this.contactList];
      return;
    }

    const searchLower = searchValue.toString().toLowerCase().trim();
    this.filteredContactList = this.contactList.filter((contact) => {
      const fullName = `${contact?.name ?? ''} ${contact?.surName ?? ''}`
        .toString()
        .toLowerCase();
      const email = (contact?.email ?? '').toString().toLowerCase();
      const phone = (contact?.phone ?? '').toString().toLowerCase();
      const mobile = (contact?.mobile ?? '').toString().toLowerCase();
      const idStr = (contact?.id ?? '').toString().toLowerCase();

      return (
        fullName.includes(searchLower) ||
        email.includes(searchLower) ||
        phone.includes(searchLower) ||
        mobile.includes(searchLower) ||
        idStr.includes(searchLower)
      );
    });
  }

  /**
   * Filtrar la lista de empresas cliente según el texto de búsqueda
   * @param searchValue Texto ingresado en el buscador
   */
  onClientCompanySearch(searchValue: string): void {
    if (!searchValue || searchValue.trim() === '') {
      // Si no hay búsqueda, mostrar todas las empresas
      this.filteredCompaniesList = [...this.companiesList];
      return;
    }

    const searchLower = searchValue.toLowerCase().trim();
    this.filteredCompaniesList = this.companiesList.filter((company) =>
      company.name?.toLowerCase().includes(searchLower),
    );
  }

  /**
   * Filtrar la lista de empresas intermediarias según el texto de búsqueda
   */
  onIntermediaryCompanySearch(searchValue: string): void {
    if (!searchValue || searchValue.trim() === '') {
      this.filteredIntermediaryCompaniesList = [...this.companiesList];
      return;
    }
    const searchLower = searchValue.toLowerCase().trim();
    this.filteredIntermediaryCompaniesList = this.companiesList.filter((company) =>
      company.name?.toLowerCase().includes(searchLower),
    );
  }

  // Método para filtrar comerciales según el equipo de ventas seleccionado
  onSalesTeamChange(teamId: number | null): void {
    console.log('onSalesTeamChange llamado con teamId:', teamId);

    if (!teamId) {
      // Si no hay equipo seleccionado, limpiar la lista y deshabilitar el campo comercial
      this.filteredCommercialList = [];
      this.hasTeamMembers = false;
      this.oportunitiesForm.get('commercial')?.setValue(null);
      this.oportunitiesForm.get('commercial')?.disable();
      return;
    }

    if (!this.isInitialStageCompatibleWithTeam(teamId)) {
      this.notificationService.error(
        'Equipo no compatible',
        `La etapa "${this.getInitialStageName()}" no pertenece al equipo de ventas seleccionado.`,
      );
      this.oportunitiesForm.get('salesTeam')?.setValue(null, { emitEvent: false });
      this.oportunitiesForm.get('commercial')?.setValue(null);
      this.oportunitiesForm.get('commercial')?.disable();
      this.filteredCommercialList = [];
      this.hasTeamMembers = false;
      return;
    }

    // Siempre limpiar el comercial seleccionado cuando cambia el equipo
    this.oportunitiesForm.get('commercial')?.setValue(null);

    // Habilitar el campo comercial
    this.oportunitiesForm.get('commercial')?.enable();

    // Verificar si necesitamos cargar los datos completos del equipo
    const selectedTeam = this.allSalesTeamList.find((team) => team.id === teamId);

    if (
      !selectedTeam ||
      !selectedTeam.memberList ||
      selectedTeam.memberList.length === 0
    ) {
      // Si el equipo no tiene memberList, intentar cargar los datos completos
      console.log(
        'El equipo no tiene memberList, intentando cargar datos completos...',
      );
      this.loadSalesTeamDetails(teamId);
    } else {
      // Si ya tiene memberList, filtrar directamente
      this.filterCommercialsByTeam(teamId);
    }
  }

  // Cargar los miembros del equipo de ventas usando el endpoint salesteammember
  loadSalesTeamDetails(teamId: number): void {
    const url = `${environment.coreApiBaseUrl}/api/salesteammember`;
    const params = new HttpParams()
      .set('teamId', teamId.toString())
      .set('startRow', '0')
      .set('endRow', '100')
      .set('sortDirection', 'desc')
      .set('sortProperty', 'id');

    const headers = this.companyService.getCompanyHeaders();

    this.http
      .get<any>(url, { params, headers })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response) => {
          console.log('Respuesta del endpoint salesteammember:', response);

          if (response?.data?.rows && response.data.rows.length > 0) {
            // Convertir los miembros al formato memberList que espera el código
            const memberList = response.data.rows.map((member: any) => ({
              userId: member.userId,
              id: member.userId, // Para compatibilidad
              role: member.role,
              isActive: member.isActive,
            }));

            // Actualizar el equipo en la lista local con los miembros
            const teamIndex = this.allSalesTeamList.findIndex(
              (t) => t.id === teamId,
            );
            if (teamIndex !== -1) {
              this.allSalesTeamList[teamIndex] = {
                ...this.allSalesTeamList[teamIndex],
                memberList: memberList,
                members: response.data.rows, // También guardar los miembros completos
              } as any;
              this.salesTeamList = this.filterSalesTeamsForInitialStage(
                this.allSalesTeamList,
              );
              console.log(
                'Equipo actualizado con miembros:',
                this.allSalesTeamList[teamIndex],
              );
            } else {
              // Si no existe, agregarlo
              const teamData: any = {
                id: teamId,
                memberList: memberList,
                members: response.data.rows,
              };
              this.allSalesTeamList.push(teamData);
              this.salesTeamList = this.filterSalesTeamsForInitialStage(
                this.allSalesTeamList,
              );
              console.log('Equipo agregado a la lista con miembros:', teamData);
            }

            // Filtrar los comerciales con los miembros cargados
            this.hasTeamMembers = true;
            this.filterCommercialsByTeam(teamId);
          } else {
            console.warn('No se encontraron miembros para el equipo:', teamId);
            // Si no hay miembros, dejar la lista vacía y deshabilitar el campo
            const teamIndex = this.allSalesTeamList.findIndex(
              (t) => t.id === teamId,
            );
            if (teamIndex !== -1) {
              this.allSalesTeamList[teamIndex] = {
                ...this.allSalesTeamList[teamIndex],
                memberList: [],
                members: [],
              } as any;
              this.salesTeamList = this.filterSalesTeamsForInitialStage(
                this.allSalesTeamList,
              );
            }
            // Dejar la lista vacía si no hay miembros
            this.filteredCommercialList = [];
            this.hasTeamMembers = false;
            // Limpiar el comercial seleccionado si había uno
            this.oportunitiesForm.get('commercial')?.setValue(null);
            // Deshabilitar el campo si no hay miembros
            this.oportunitiesForm.get('commercial')?.disable();
          }
        },
        error: (error) => {
          console.error('Error al cargar miembros del equipo:', error);
          // Si falla, intentar filtrar con los datos disponibles
          this.filterCommercialsByTeam(teamId);
        },
      });
  }

  // Método auxiliar para filtrar comerciales por equipo
  filterCommercialsByTeam(teamId: number): void {
    console.log('filterCommercialsByTeam llamado con teamId:', teamId);
    console.log('Lista completa de equipos:', this.allSalesTeamList);
    let selectedTeam = this.allSalesTeamList.find((team) => team.id === teamId);

    // Si no se encuentra en la lista local, intentar buscarlo en globalValuesService
    if (!selectedTeam) {
      console.warn(
        'No se encontró el equipo con id:',
        teamId,
        'en la lista local',
      );
      const teamsFromGlobal = this.globalValuesService.salesTeams$.value;
      selectedTeam = teamsFromGlobal.find((team) => team.id === teamId);
      if (selectedTeam) {
        console.log('Equipo encontrado en globalValuesService:', selectedTeam);
        // Agregarlo a la lista completa local
        this.allSalesTeamList.push(selectedTeam as any);
        this.salesTeamList = this.filterSalesTeamsForInitialStage(
          this.allSalesTeamList,
        );
      }
    }

    console.log('Equipo encontrado:', selectedTeam);
    console.log('memberList del equipo:', selectedTeam?.memberList);

    if (!selectedTeam) {
      console.warn('No se encontró el equipo con id:', teamId);
      console.warn(
        'IDs disponibles en la lista:',
        this.allSalesTeamList.map((t) => t.id),
      );
      // Si no se encuentra el equipo, dejar la lista vacía
      this.filteredCommercialList = [];
      this.hasTeamMembers = false;
      // Limpiar el comercial seleccionado
      this.oportunitiesForm.get('commercial')?.setValue(null);
      // Deshabilitar el campo
      this.oportunitiesForm.get('commercial')?.disable();
      return;
    }

    // Verificar si el equipo tiene memberList
    if (!selectedTeam.memberList || selectedTeam.memberList.length === 0) {
      console.warn(
        'El equipo no tiene memberList o está vacío. No se mostrarán comerciales.',
      );
      // Si no hay miembros, dejar la lista vacía
      this.filteredCommercialList = [];
      this.hasTeamMembers = false;
      // Limpiar el comercial seleccionado si había uno
      this.oportunitiesForm.get('commercial')?.setValue(null);
      // Deshabilitar el campo si no hay miembros
      this.oportunitiesForm.get('commercial')?.disable();
      return;
    }

    // Si hay miembros, actualizar el flag
    this.hasTeamMembers = true;

    // Obtener los userIds de los miembros del equipo
    const teamMemberUserIds = selectedTeam.memberList
      .map((member: any) => {
        // member puede ser un objeto con userId o solo el id directamente
        if (typeof member === 'object' && member !== null) {
          return member.userId || member.id;
        }
        return member; // Si es un número directamente
      })
      .filter((id: number) => id != null && true);

    console.log('UserIds de los miembros del equipo:', teamMemberUserIds);

    // Filtrar los comerciales que pertenecen al equipo
    // Crear un nuevo array para asegurar que Angular detecte el cambio
    const filtered = this.commercialList.filter((partner) => {
      const user = this.usersList.find((u) => u.partner?.id === partner.id);
      const belongsToTeam = user && teamMemberUserIds.includes(user.id);
      if (belongsToTeam) {
        console.log('Comercial incluido:', partner.name, 'userId:', user?.id);
      }
      return belongsToTeam;
    });

    // Asignar el nuevo array para forzar la detección de cambios
    this.filteredCommercialList = [...filtered];

    console.log(
      'Lista de comerciales filtrados:',
      this.filteredCommercialList.map((c) => c.name),
    );
    console.log(
      'Total de comerciales filtrados:',
      this.filteredCommercialList.length,
    );
  }

  // Método para reaccionar cuando se selecciona un comercial
  // OJO: Los campos de contacto (empresa cliente, email, teléfono, etc.)
  // pertenecen al CONTACTO, no al comercial, por lo que no se rellenan aquí.
  onCommercialChange(commercialId: number): void {
    console.log('onCommercialChange', commercialId);
    if (!commercialId || !this.usersList?.length) {
      return;
    }

    // Buscar el usuario correspondiente al partner seleccionado
    const selectedUser = this.usersList.find(
      (user) => user.partner?.id === commercialId,
    );

    if (!selectedUser) {
      return;
    }

    const user = selectedUser as any;
    const partner = user.partner;

    // De momento solo dejamos el log para depuración,
    // sin tocar campos de contacto del formulario.
    console.log('Comercial seleccionado (partner):', {
      partner,
      userId: user.id,
    });
  }

  ngOnInit(): void {
    this.partner = this.nzData.element;
    this.columnsData = this.nzData.columnsData;

    // Set isLead property once
    this.isLead = this.nzData.type === 'Lead';

    // Cargar listas de centro de costo y equipo de ventas igual que en el resto (valor actual de globalValues)
    this.costCenterList = this.globalValuesService.costCenters$.value || [];
    this.allSalesTeamList = this.globalValuesService.salesTeams$.value || [];
    this.salesTeamList = this.filterSalesTeamsForInitialStage(
      this.allSalesTeamList,
    );

    // Check if the partner is an employee (may use 'employee' property instead)
    this.isEmployee =
      this.partner?.isEmployee || this.partner?.employee || false;

    // Get the documents if available or load them
    if (this.partner?.documents?.length) {
      this.documents = this.partner.documents;
    } else if (this.partner?.id) {
      this.loadPartnerDocuments(this.partner.id);
    }

    // Load document types
    this.loadDocumentTypes();

    // Load projects
    this.loadProjects();

    // Inicializar formulario
    this.initForm();

    // Configurar autocompletado de contacto
    this.setupContactAutoFill();

    // Suscribirse a cambios en salesTeam para filtrar comerciales
    this.oportunitiesForm
      .get('salesTeam')
      ?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((teamId: number | null) => {
        this.onSalesTeamChange(teamId);
      });

    this.applyInitialStage();

    // Suscribirse a cambios en clientCompany para cargar contactos filtrados
    this.oportunitiesForm
      .get('clientCompany')
      ?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((companyId: number | null) => {
        if (!companyId) {
          // Resetear lista si no hay empresa seleccionada
          this.contactList = this.globalValuesService.isPartnerReady$.value
            ? this.globalValuesService.origenContactList
            : [];
          this.filteredContactList = [...this.contactList];
          // Deshabilitar campos de contacto, email y teléfono
          this.oportunitiesForm.get('contact')?.disable();
          this.oportunitiesForm.get('email')?.disable();
          this.oportunitiesForm.get('phone')?.disable();
          // Limpiar valores
          this.oportunitiesForm.patchValue(
            {
              contact: '',
              email: '',
              phone: '',
            },
            { emitEvent: false },
          );
          return;
        }

        // Habilitar campos de contacto, email y teléfono cuando se selecciona una empresa
        this.oportunitiesForm.get('contact')?.enable();
        this.oportunitiesForm.get('email')?.enable();
        this.oportunitiesForm.get('phone')?.enable();

        // Construir payload conforme a la especificación requerida
        const payload = {
          filterGroups: [
            [
              { property: 'isCompany', value: 'false', operator: 'Equals' },
              {
                property: 'parentId',
                value: String(companyId),
                operator: 'Equals',
              },
            ],
          ],
          startRow: 0,
          endRow: 99999999,
          sortDirection: 'asc',
          sortProperty: 'name',
        };

        this.contactLoading = true;
        this.partnerService
          .postAdvanced(payload)
          .pipe(
            takeUntilDestroyed(this.destroyRef),
            finalize(() => (this.contactLoading = false)),
          )
          .subscribe({
            next: (rows: Partner[]) => {
              this.contactList = rows || [];
              this.filteredContactList = [...this.contactList];
            },
            error: () => {
              this.contactList = [];
              this.filteredContactList = [];
            },
          });
      });

    // Verificar si hay un comercial pre-seleccionado y autocompletar su información
    setTimeout(() => {
      const currentCommercialId =
        this.oportunitiesForm?.get('commercial')?.value;
      if (currentCommercialId && this.usersList?.length > 0) {
        this.onCommercialChange(currentCommercialId);
      }
    }, 500);

    // Registrar handler nativo en fase de captura para interceptar Escape
    this.drawerEscapeBlocker.block();
  }

  initForm(): void {
    const contactValidators = [Validators.required];

    this.oportunitiesForm = this.fb.group({
      name: ['', Validators.required],
      opportunityType: [null],
      probability: [0],
      expectedClosingDate: [null],
      source: [''],
      description: [''],
      email: [{ value: '', disabled: true }],
      phone: [{ value: '', disabled: true }],
      mobile: [''],
      street: [''],
      street2: [''],
      city: [''],
      province: [''],
      zip: [''],
      website: [''],
      isActive: [true],
      partnerId: [0],
      userId: [0],
      teamId: [0],
      stageId: [0],
      lostReasonId: [0],
      countryId: [null],
      stateId: [null],
      chatId: [0],
      companyId: [this.companyService.selectedCompanyId$.value || null],
      odooEntityId: [0],
      // Campos adicionales del formulario
      contactName: [''],
      jobTitle: [''],
      priority: [null],
      tags: [null],
      projects: [null],
      costCenter: [null],
      commercial: [
        {
          value: this.authService.loggedUser$.value?.partner?.id || null,
          disabled: true,
        },
        Validators.required,
      ],
      contact: [{ value: '', disabled: true }, contactValidators],
      intermediaryCompanyId: [null],
      clientCompany: [null, Validators.required],
      salesTeam: [null, Validators.required],
      // Campos del Step 2: Información Adicional
      campaign: [''],
      medium: [''],
      referencedById: [''],
      dateAssignment: [null],
      dateClose: [null],
      type: [null],
    });
  }

  private applyInitialStage(): void {
    const initialStage = this.nzData.initialStage;
    const stageId = initialStage?.id ?? initialStage?.key;

    if (stageId === null || stageId === undefined || stageId === '') {
      return;
    }

    const numericStageId = Number(stageId);
    if (!Number.isFinite(numericStageId)) {
      return;
    }

    this.oportunitiesForm.patchValue({
      stageId: numericStageId,
    });
  }

  private filterSalesTeamsForInitialStage<T extends { id: number | string }>(
    teams: T[],
  ): T[] {
    const allowedTeamIds = this.getInitialStageTeamIds();

    if (!allowedTeamIds || allowedTeamIds.length === 0) {
      return teams;
    }

    return teams.filter((team) =>
      allowedTeamIds.some((teamId) => teamId === team.id),
    );
  }

  private isInitialStageCompatibleWithTeam(teamId: number | string): boolean {
    const allowedTeamIds = this.getInitialStageTeamIds();

    return (
      !allowedTeamIds ||
      allowedTeamIds.length === 0 ||
      allowedTeamIds.some((allowedTeamId) => allowedTeamId === teamId)
    );
  }

  private getInitialStageTeamIds(): Array<number | string> | null {
    const initialStage = this.nzData.initialStage;
    const stageId = initialStage?.id ?? initialStage?.key;

    if (!stageId) {
      return null;
    }

    const stage = this.globalValuesService.stages$.value.find(
      (item: any) => Number(item?.id) === Number(stageId),
    );

    return this.getStageTeamIds(stage);
  }

  private getStageTeamIds(stage: any): Array<number | string> | null {
    if (!stage) {
      return null;
    }

    if (Array.isArray(stage.teamIds)) {
      return stage.teamIds
        .map((team: any) => team?.id ?? team)
        .filter((teamId: any) => teamId !== null && teamId !== undefined);
    }

    if (Array.isArray(stage.teams)) {
      return stage.teams
        .map((team: any) => team?.id ?? team)
        .filter((teamId: any) => teamId !== null && teamId !== undefined);
    }

    return null;
  }

  private getInitialStageName(): string {
    const initialStage = this.nzData.initialStage;
    const stageId = initialStage?.id ?? initialStage?.key;
    const stage = this.globalValuesService.stages$.value.find(
      (item: any) => Number(item?.id) === Number(stageId),
    );

    return initialStage?.title || stage?.name || 'seleccionada';
  }

  /**
   * Configura el autocompletado de campos cuando se selecciona un contacto.
   * Para Leads, el contacto es opcional: si se selecciona, se rellenan datos,
   * si no se selecciona, el usuario puede escribirlos a mano.
   */
  setupContactAutoFill(): void {
    this.oportunitiesForm
      .get('contact')
      ?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((contactId: number | null) => {
        if (contactId && this.contactList.length > 0) {
          const selectedContact = this.contactList.find(
            (contact) => contact.id === contactId,
          );
          console.log('selectedContact', selectedContact);
          if (selectedContact) {
            // Preparar los valores a actualizar
            const updates: any = {};

            // Email: usar email del contacto si existe
            if (selectedContact.email) {
              updates.email = selectedContact.email;
            } else {
              // Si el contacto no tiene email, limpiar el campo
              updates.email = '';
            }

            // Teléfono: usar phone, si no existe usar mobile
            if (selectedContact.phone) {
              updates.phone = selectedContact.phone;
            } else if (selectedContact.mobile) {
              updates.phone = selectedContact.mobile;
            } else {
              // Si el contacto no tiene teléfono, limpiar el campo
              updates.phone = '';
            }

            // No actualizar `clientCompany` aquí para evitar cambiar el selector
            // (El selector `clientCompany` está ligado a company.id; mantenerlo intacto)

            // Nombre del contacto
            if (selectedContact.name) {
              updates.contactName = selectedContact.name;
            }

            // Dirección y otros datos si existen
            if (selectedContact.street) {
              updates.street = selectedContact.street;
            }
            if (selectedContact.street2) {
              updates.street2 = selectedContact.street2;
            }
            if (selectedContact.city) {
              updates.city = selectedContact.city;
            }
            if (selectedContact.zip) {
              updates.zip = selectedContact.zip;
            }
            if (selectedContact.website) {
              updates.website = selectedContact.website;
            }

            // Actualizar todos los campos cuando cambias de contacto
            // Esto asegura que los datos se refresquen correctamente
            this.oportunitiesForm.patchValue(updates, { emitEvent: false });
          }
        } else if (!contactId) {
          // Si se deselecciona el contacto, limpiar los campos relacionados
          // NOTA: no tocar `clientCompany` para no afectar el selector
          this.oportunitiesForm.patchValue(
            {
              email: '',
              phone: '',
              contactName: '',
              jobTitle: '',
              street: '',
              street2: '',
              city: '',
              zip: '',
              website: '',
            },
            { emitEvent: false },
          );
        }
      });
  }

  // Método para manejar cuando se crea un nuevo contacto
  onPartnerCreated(newPartner: Partner): void {
    // Agregar el nuevo partner a la lista de contactos
    if (!this.contactList.find(p => p.id === newPartner.id)) {
      this.contactList.push(newPartner);
      this.filteredContactList.push(newPartner);
    }

    // Seleccionar el nuevo contacto en el formulario
    this.oportunitiesForm.patchValue({
      contact: newPartner.id,
    });

    // Actualizar campos relacionados (email, teléfono, nombre)
    this.oportunitiesForm.patchValue({
      email: newPartner.email || null,
      phone: newPartner.phone || null,
      contactName: newPartner.name || '',
    });
  }

  handleQuillLink(value: boolean): void {
    if (!this.quillEditorRef) return;
    const quill = this.quillEditorRef.quillEditor;
    if (!quill) return;
    const range = quill.getSelection(true);
    if (value) {
      if (range && range.length > 0) {
        const formats = quill.getFormat(range);
        const currentLink = (formats['link'] as string) || '';
        this.showLinkModal(currentLink, quill, { index: range.index, length: range.length });
      } else {
        this.modalService.warning({
          nzTitle: 'Seleccione texto',
          nzContent: 'Por favor, seleccione el texto al que desea agregar el enlace.',
          nzCentered: true,
          nzWidth: 400,
        });
      }
    } else {
      if (range && range.length > 0) quill.format('link', false);
    }
  }

  showLinkModal(currentUrl: string, quill: any, range: { index: number; length: number }): void {
    this.linkModalUrl = currentUrl || '';
    this.linkModalQuill = quill;
    this.linkModalRange = range;
    this.cdr.detectChanges();
    this.linkModalRef = this.modalService.create({
      nzTitle: currentUrl ? 'Editar enlace' : 'Agregar enlace',
      nzContent: this.linkModalTemplate,
      nzFooter: this.linkModalFooterTemplate,
      nzBodyStyle: { padding: '24px' },
      nzCentered: true,
      nzWidth: 500,
      nzClosable: true,
      nzMaskClosable: false,
    });
    setTimeout(() => {
      if (this.linkInput?.nativeElement) {
        this.linkInput.nativeElement.focus();
        this.linkInput.nativeElement.select();
      }
    }, 200);
  }

  closeLinkModal(): void {
    this.linkModalRef?.close();
    this.linkModalQuill = null;
    this.linkModalRange = null;
    this.linkModalUrl = '';
  }

  onLinkModalEnter(): void {
    this.onLinkModalConfirm();
  }

  private normalizeLinkUrl(url: string): string {
    const u = url.trim();
    if (!u) return u;
    if (/^https?:\/\//i.test(u)) return u;
    return 'https://' + u;
  }

  onLinkModalConfirm(): void {
    const url = (this.linkModalUrl || '').trim();
    if (!url || !this.linkModalQuill || !this.linkModalRange) {
      this.closeLinkModal();
      return;
    }
    const normalized = this.normalizeLinkUrl(url);
    this.linkModalRef?.close();
    setTimeout(() => {
      if (!this.linkModalQuill || !this.linkModalRange) {
        this.linkModalQuill = null;
        this.linkModalRange = null;
        this.linkModalUrl = '';
        return;
      }
      this.linkModalQuill.focus();
      this.linkModalQuill.setSelection(this.linkModalRange.index, this.linkModalRange.length);
      this.linkModalQuill.format('link', normalized);
      // Sincronizar el contenido del editor con el formulario
      const htmlContent = this.linkModalQuill.root.innerHTML;
      this.oportunitiesForm.get('description')?.setValue(htmlContent);
      this.linkModalQuill = null;
      this.linkModalRange = null;
      this.linkModalUrl = '';
    }, 100);
  }

  close(): void {
    this.drawerRef.close();
  }

  ngOnDestroy(): void {
    // Remover listener nativo si fue registrado
    this.drawerEscapeBlocker.block();
  }

  // Helper method to find option name by ID
  findOptionNameById(id: number | null, list: any[]): string {
    if (id === null || id === undefined) return '-';
    return list.find((item) => item.id === id)?.name || '-';
  }

  // Helper method to check if a value is empty
  isEmpty(value: any): boolean {
    return value === null || value === undefined || value === '';
  }

  // Helper method to get the appropriate icon for a document based on its extension
  getDocumentIcon(extension: string): string {
    const ext = extension?.toLowerCase();

    switch (ext) {
      case 'pdf':
        return 'pdf';
      case 'doc':
      case 'docx':
        return 'document';
      case 'xls':
      case 'xlsx':
        return 'spreadsheet';
      case 'ppt':
      case 'pptx':
        return 'presentation';
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return 'image';
      default:
        return 'file';
    }
  }

  // Format file size to human-readable format
  formatFileSize(size: string | number): string {
    if (!size) return '0 KB';

    let numSize: number;
    if (typeof size === 'string') {
      numSize = parseInt(size, 10);
      if (isNaN(numSize)) return '0 KB';
    } else {
      numSize = size;
    }

    if (numSize < 1024) {
      return numSize + ' B';
    } else if (numSize < 1024 * 1024) {
      return Math.round(numSize / 1024) + ' KB';
    } else {
      return Math.round((numSize / (1024 * 1024)) * 10) / 10 + ' MB';
    }
  }

  // Load the documents for this partner
  loadPartnerDocuments(partnerId: number): void {
    const getParams = {
      startRow: 0,
      endRow: 100,
      sortDirection: 'asc',
      sortProperty: 'id',
      entityId: partnerId,
      entityType: 'Partner',
    };

    this.documentService.getDocument(getParams).subscribe({
      next: (response) => {
        if (response && response.data && response.data.rows) {
          this.documents = response.data.rows;
        }
      },
      error: (error) => {
        console.error('Error loading partner documents:', error);
      },
    });
  }

  // Load document types
  loadDocumentTypes(): void {
    const getParams: GetParams = {
      startRow: 0,
      endRow: 100,
      sortDirection: 'asc',
      sortProperty: 'id',
    };

    this.documentService.getDocumentType(getParams).subscribe({
      next: (response) => {
        if (response && response.data && response.data.rows) {
          this.documentTypes = response.data.rows;
        }
      },
      error: (error) => {
        console.error('Error loading document types:', error);
      },
    });
  }

  loadProjects(): void {
    this.loadingProjects = true;
    const params: GetParams = {
      startRow: 0,
      endRow: 10000,
      sortDirection: 'asc',
      sortProperty: 'id',
    };

    this.projectService
      .getProjectByCompanies(params)
      .pipe(finalize(() => (this.loadingProjects = false)))
      .subscribe({
        next: (response) => {
          if (response.statusCode === 200) {
            this.projectsList = (response.data.rows || []).filter((project: any) =>
              isProjectAvailableForOpportunity(project),
            );
          }
        },
        error: (error) => {
          console.error('Error loading projects:', error);
        },
      });
  }

  onProjectSelectChange(value: number | string | null): void {
    if (value !== this.createProjectOptionValue) {
      return;
    }

    this.oportunitiesForm.patchValue({ projects: null });
    this.openCreateProjectDrawer();
  }

  openCreateProjectDrawer(event?: MouseEvent): void {
    event?.preventDefault();
    event?.stopPropagation();

    const createProjectDrawer = this.drawerService.create({
      nzWidth: 793,
      nzHeight: '98%',
      nzPlacement: 'right',
      nzClosable: false,
      nzMaskClosable: false,
      nzContent: CreateProjectDrawerComponent,
      nzData: {
        type: 'Opportunity',
      },
    });

    createProjectDrawer.afterOpen.pipe(take(1)).subscribe(() => {
      const contentComponent = createProjectDrawer.getContentComponent();
      if (contentComponent?.createEvent) {
        contentComponent.createEvent.pipe(take(1)).subscribe((project: any) => {
          const projectId = project?.id;
          this.loadProjects();
          if (projectId) {
            this.oportunitiesForm.patchValue({ projects: projectId });
          }
        });
      }
    });
  }

  // Get document type name by ID
  getDocumentTypeName(documentTypeId: number): string {
    const docType = this.documentTypes.find((dt) => dt.id === documentTypeId);
    return docType ? docType.name : 'Sin tipo';
  }

  // Download document
  downloadDocument(document: any): void {
    this.documentService.openDocumentInNewTab(document);
  }

  // Helper method to get filtered options from columnsData
  getOptionList(fieldName: string): any[] {
    const column = this.columnsData.find((c) => c.pathData?.name === fieldName);
    return column?.optionList || [];
  }

  openEditDrawer() {
    this.openEditDrawerEvent.emit(this.nzData.element.id);
  }

  isStepOneValid(): boolean {
    // Campos obligatorios en el step 1:
    // - Siempre: name
    // - Siempre: salesTeam
    // - Solo oportunidades (no leads): opportunityType y costCenter
    const nameValid = !!this.oportunitiesForm.get('name')?.valid;
    const salesTeamValid = !!this.oportunitiesForm.get('salesTeam')?.valid;
    const commercialControl = this.oportunitiesForm.get('commercial');
    const commercialValid = !commercialControl?.enabled || !!commercialControl?.valid;

    const baseValid = nameValid && salesTeamValid && commercialValid;

    // Para Oportunidades, también validar opportunityType y costCenter
    if (!this.isLead) {
      const opportunityTypeValid =
        !!this.oportunitiesForm.get('opportunityType')?.valid;
      const costCenterValid = !!this.oportunitiesForm.get('costCenter')?.valid;

      return baseValid && opportunityTypeValid && costCenterValid;
    }

    // Para Leads, solo los campos base
    return baseValid;
  }

  createOpportunity(createAndNew: boolean = false): void {
    if (this.oportunitiesForm.invalid) {
      this.notificationService.error(
        'Error',
        'Por favor completa los campos requeridos',
      );
      return;
    }

    const selectedTeamId = this.oportunitiesForm.get('salesTeam')?.value;
    if (selectedTeamId && !this.isInitialStageCompatibleWithTeam(selectedTeamId)) {
      this.notificationService.error(
        'Equipo no compatible',
        `No se puede crear en la etapa "${this.getInitialStageName()}" con el equipo de ventas seleccionado.`,
      );
      return;
    }

    if (createAndNew) {
      this.savingAndNew = true;
    } else {
      this.savingAndClose = true;
    }

    const formValue = this.oportunitiesForm.value;

    // Obtener el userId del comercial (partnerId)
    const commercialUserId = formValue.commercial
      ? this.usersList.find((user) => user.partner?.id === formValue.commercial)
          ?.id || 0
      : 0;

    // Mapear el tipo de oportunidad al valor que espera el backend
    // Puede venir de opportunityType (Step 1) o type (Step 2)
    let opportunityTypeValue = null;
    const typeValue = formValue.opportunityType || formValue.type;
    if (typeValue === 'Proyecto' || typeValue === 'Project') {
      opportunityTypeValue = 'project';
    } else if (
      typeValue === 'Servicio Puntual' ||
      typeValue === 'PunctualService'
    ) {
      opportunityTypeValue = 'punctualservice';
    }

    // Mapear los valores del formulario al payload del backend
    const payload = {
      name: formValue.name || null,
      type: this.nzData.type === 'Lead' ? 'Lead' : 'Opportunity', // Enviar 'Lead' cuando es lead
      opportunityType: opportunityTypeValue || null,
      probability: formValue.probability
        ? parseFloat(formValue.probability)
        : null,
      expectedClosingDate: formValue.expectedClosingDate
        ? new Date(formValue.expectedClosingDate).toISOString()
        : null,
      source: formValue.source || null,
      description: formValue.description || null,
      email: formValue.email || null,
      phone: formValue.phone || null,
      mobile: formValue.mobile || null,
      street: formValue.street || null,
      street2: formValue.street2 || null,
      city: formValue.city || null,
      province: formValue.province || null,
      zip: formValue.zip || null,
      website: formValue.website || null,
      jobTitle: formValue.jobTitle || null,
      isActive: formValue.isActive !== undefined ? formValue.isActive : true,
      partnerId:
        typeof formValue.contact === 'number' ? formValue.contact : 587,
      // Solo incluir userId si hay un comercial seleccionado y el equipo tiene miembros
      // Si el equipo no tiene miembros, no incluir userId en el payload
      ...(commercialUserId && this.hasTeamMembers
        ? { userId: commercialUserId }
        : formValue.userId && this.hasTeamMembers
        ? { userId: formValue.userId }
        : {}),
      stageId: formValue.stageId || null,
      lostReasonId: formValue.lostReasonId || null,
      countryId: formValue.countryId || null,
      stateId: formValue.stateId || null,
      chatId: formValue.chatId || null,
      companyId:
        formValue.companyId ||
        this.companyService.selectedCompanyId$.value ||
        null,
      costCenterId: formValue.costCenter || null,
      odooEntityId: formValue.odooEntityId || null,
      priority: formValue.priority || null,
      teamId: formValue.salesTeam || formValue.teamId || null,
      projectId: formValue.projects ?? null,
      intermediaryCompanyId: formValue.intermediaryCompanyId || null,
      // Campos del Step 2: Información Adicional
      campaign: formValue.campaign || null,
      medium: formValue.medium || null,
      referencedById: formValue.referencedById || null,
      dateAssignment: formValue.dateAssignment
        ? new Date(formValue.dateAssignment).toISOString()
        : null,
      dateClose: formValue.dateClose
        ? new Date(formValue.dateClose).toISOString()
        : null,
    };

    // Agregar currencyId si hay un valor válido
    // Si no se selecciona currencyId, usar el de la company asociada
    const finalCompanyId =
      formValue.companyId ||
      this.companyService.selectedCompanyId$.value ||
      null;

    let currencyIdValue = formValue.currencyId || null;

    if (!currencyIdValue && finalCompanyId) {
      const company = this.allCompaniesList.find(
        (c) => c.id === finalCompanyId
      );
      currencyIdValue = company?.currencyId || null;
    }

    // Solo incluir currencyId si tiene un valor válido (no null)
    if (currencyIdValue !== null && currencyIdValue !== undefined) {
      (payload as any).currencyId = currencyIdValue;
    }

    // Usar el endpoint correcto según el tipo
    const createObservable =
      this.nzData.type === 'Lead'
        ? this.opportunityService.createLead(payload)
        : this.opportunityService.createOpportunity(payload);

    createObservable.pipe(
      finalize(() => {
        this.savingAndNew = false;
        this.savingAndClose = false;
        this.cdr.detectChanges();
      }),
    ).subscribe({
      next: (response) => {
        if (response.success) {
          // Configurar toast de éxito
          const entityName =
            this.nzData.type === 'Lead' ? 'Lead' : 'Oportunidad';
          this.toastConfig = {
            icon: 'check_circle',
            iconColor: '#6CDA75',
            content: `${entityName} creada exitosamente.`,
            showUndo: false,
          };

          // Asegurar que el ViewChild esté disponible antes de crear la notificación
          this.cdr.detectChanges();
          setTimeout(() => {
            if (this.notificationTmpl) {
              this.notRef = this.notificationService.create(
                'blank',
                '',
                this.notificationTmpl,
                { nzPlacement: 'bottomRight', nzDuration: 3000 },
              );
            }
          }, 0);

          if (createAndNew) {
            // Resetear el formulario para crear otra
            this.oportunitiesForm.reset();
            this.initForm();
            this.applyInitialStage();
            this.filteredCompaniesList = [...this.companiesList];
            this.filteredIntermediaryCompaniesList = [...this.companiesList];
            this.step = 1;
          } else {
            // Cerrar el drawer después de un breve delay para mostrar la notificación
            setTimeout(() => {
              this.drawerRef.close(response.data ?? true);
            }, 500);
          }
        } else {
          // Configurar toast de error
          const entityName =
            this.nzData.type === 'Lead' ? 'Lead' : 'Oportunidad';
          this.toastConfig = {
            icon: 'dangerous',
            iconColor: '#CB2A2F',
            content:
              response.message ||
              `Error al crear la ${entityName.toLowerCase()}.`,
            showUndo: false,
          };

          // Asegurar que el ViewChild esté disponible antes de crear la notificación
          this.cdr.detectChanges();
          setTimeout(() => {
            if (this.notificationTmpl) {
              this.notRef = this.notificationService.create(
                'blank',
                '',
                this.notificationTmpl,
                { nzPlacement: 'bottomRight', nzDuration: 3000 },
              );
            }
          }, 0);
        }
      },
      error: (error) => {
        // Configurar toast de error (savingAndNew/savingAndClose se resetean en finalize)
        const entityName = this.nzData.type === 'Lead' ? 'Lead' : 'Oportunidad';
        this.toastConfig = {
          icon: 'dangerous',
          iconColor: '#CB2A2F',
          content:
            error.error?.message ||
            `Error al crear la ${entityName.toLowerCase()}.`,
          showUndo: false,
        };

        // Asegurar que el ViewChild esté disponible antes de crear la notificación
        setTimeout(() => {
          if (this.notificationTmpl) {
            this.notRef = this.notificationService.create(
              'blank',
              '',
              this.notificationTmpl,
              { nzPlacement: 'bottomRight', nzDuration: 3000 },
            );
          }
        }, 0);
      },
    });
  }

  protected readonly isExpirationAlert = isExpirationAlert;

  // Función para deshabilitar fechas anteriores a hoy
  disabledPastDate = (current: Date): boolean => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const currentDate = new Date(current);
    currentDate.setHours(0, 0, 0, 0);
    // Retorna true si la fecha es anterior a hoy (debe estar deshabilitada)
    return currentDate < today;
  };
}
